module.exports = __webpack_public_path__ + "img/iconLiShiShangTongZhuangChe.6e55f5d0.svg";